import { useState, useEffect } from "react";
import { wabaApi } from "../../lib/wabaApi";

// Mesmo app; configuração de Login PRÓPRIA do Messenger: sem permissões de
// Instagram, senão loja com Página mas sem Instagram não conseguiria conceder
// tudo e o login falharia inteiro (a Meta concede tudo ou nada).
const META_APP_ID = "843063592187222";
const MSN_CONFIG_ID = "923904130787102";

interface Props {
  connectionId: string;
  onSuccess: () => void;
}

/** Texto legível do erro — mesmo racional do InstagramSignup (React #31). */
function errorText(err: any): string {
  const d = err?.payload?.detail;
  if (typeof d === "string") return d;
  if (d && typeof d === "object") {
    return d.meta_message || d.error || JSON.stringify(d);
  }
  return "Erro ao vincular a Página do Facebook.";
}

export function MessengerSignup({ connectionId, onSuccess }: Props) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // Carrega o SDK da Meta (idempotente — EmbeddedSignup/InstagramSignup usam o mesmo script).
  useEffect(() => {
    if (document.getElementById("fb-jssdk")) return;
    window.fbAsyncInit = () => {
      window.FB.init({ appId: META_APP_ID, autoLogAppEvents: true, xfbml: true, version: "v25.0" });
    };
    const script = document.createElement("script");
    script.id = "fb-jssdk";
    script.src = "https://connect.facebook.net/en_US/sdk.js";
    script.async = true; script.defer = true;
    document.body.appendChild(script);
  }, []);

  async function doLink(code: string) {
    try {
      await wabaApi.post(`/connections/${connectionId}/link-messenger`, { code });
      onSuccess();
    } catch (err: any) {
      console.error("Erro ao vincular Messenger:", err);
      setError(errorText(err));
    } finally { setLoading(false); }
  }

  function handleSignup() {
    if (!window.FB) { setError("SDK da Meta ainda não carregou. Aguarde e tente novamente."); return; }
    setError(null); setLoading(true);

    // Callback SÍNCRONO: o SDK recusa async function. O trabalho async sai em
    // doLink — mesmo padrão dos outros dois signups.
    window.FB.login((response: any) => {
      const code = response?.authResponse?.code;
      if (!code) {
        setError("Cadastro cancelado ou código não retornado pela Meta.");
        setLoading(false); return;
      }
      doLink(code);
    }, {
      config_id: MSN_CONFIG_ID,
      response_type: "code",
      override_default_response_type: true,
    });
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      <button
        onClick={handleSignup}
        disabled={loading}
        style={{
          display: "flex", alignItems: "center", gap: 8,
          padding: "9px 18px",
          background: loading ? "var(--surface-input)" : "#0084FF",
          color: loading ? "var(--ink-muted)" : "#fff", border: "none", borderRadius: 8,
          fontSize: 13, fontWeight: 600, cursor: loading ? "default" : "pointer",
        }}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 0C5.373 0 0 4.975 0 11.111c0 3.498 1.744 6.614 4.469 8.654V24l4.088-2.242c1.092.301 2.246.464 3.443.464 6.627 0 12-4.974 12-11.111C24 4.975 18.627 0 12 0zm1.191 14.963l-3.055-3.26-5.963 3.26L10.732 8l3.131 3.259L19.752 8l-6.561 6.963z"/>
        </svg>
        {loading ? "Conectando..." : "Conectar Messenger"}
      </button>
      {error && <span style={{ fontSize: 12, color: "var(--danger)" }}>{error}</span>}
    </div>
  );
}
